import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../core/common/dataTable/index'; 
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import useDynamicPageSize from '../../useDynamicPageSize';
import Footer from '../../Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast, ToastContainer } from "react-toastify";
import nodeApi from "../../nodeApi";
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery,decryptQuery } from "../../utils/encryption";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import CommonSelect, { Option } from "../../core/common/commonSelect";
import TextareaAutosize from 'react-textarea-autosize';
import { useSearchParams } from "react-router-dom";
import ScheduleInterviewModal from "../interviews/ScheduleInterviewModal";
import { AnyNaptrRecord } from 'dns';
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const CustomTimeInput = (props: any) => {
  const { date, timeString, onChange } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const [hh, mm] = value.split(":").map(Number);
    if (isNaN(hh) || isNaN(mm)) {
      onChange(value);
      return;
    }

    const newTime = new Date(date);
    newTime.setHours(hh, mm, 0, 0);

    const now = new Date();

    // Prevent selecting past time when the selected date is today
    if (newTime.toDateString() === now.toDateString() && newTime < now) {
      return; // ignore invalid time
    }

    onChange(value);
  };

  return (
    <input
      type="time"
      className="form-control"
      value={timeString}
      onChange={handleChange}
      step={60}
    />
  );
};

interface Interviewer {
  id: number;
  round_id: number;
  interviewer_id: number;
  approval_status: string;
  proposed_datetime: string | null;
  comments: string | null;
  approved_at: string | null;
  created_at: string;
}

interface InterviewRound {
  id: number;
  interview_id: number;
  round_name: string | null;
  interview_type: string;
  scheduled_datetime: string;
  meeting_link: string;
  feedback_form_link: string;
  status: string;
  approval_summary: string | null;
  feedback_summary: string | null;
  reschedule_history: string | null;
  reminders: string | null;
  created_at: string;
  updated_at: string;
  interviewers: Interviewer[];
}

interface InterviewRecord {
  id: number;
  rounds: InterviewRound[];
  [key: string]: any; // fallback for other fields
}

type JobOpeningType = {
  id: number;
  job_profile: string;
  job_description: string;
  required_experience_months: number;
  job_location: string;
  status: string;
  deleted_at: string|null;
  created_at: string;
  updated_at: string;
};

const useModalWithUrlCleanup = (hideBsModal: (modalId: string) => void) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const hideModal = (modalId: string) => {
    hideBsModal(modalId); // call the original function

    if (modalId === "interview_rounds_modal") {
      searchParams.delete("interviewId");
      setSearchParams(searchParams, { replace: true });
    }
  };

  return { hideModal };
};

const Interviews: React.FC = () => {
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = useDynamicPageSize();
   const isInitialFetch = useRef(true);
   const [totalItems, setTotalItems] = useState<number>(0);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchParams] = useSearchParams();
  const interviewIdFromURL = searchParams.get("interviewId"); 
  const [showInterviewModal, setShowInterviewModal] = useState(false);
const [selectedJob, setSelectedJob] = useState<JobOpeningType | null>(null);
  const [interviewMode, setInterviewMode] = useState<"schedule" | "load"| "newRound">("newRound");
    const [selectedCandidate, setSelectedCandidate] = useState<any>(null);
const [statusModalVisible, setStatusModalVisible] = useState(false);
const [selectedRoundForStatus, setSelectedRoundForStatus] = useState<InterviewRound | null>(null);
const [newStatus, setNewStatus] = useState<string | null>(null);

// ---------- CONSTANTS ----------
const STATUSES = ["Completed", "Cancelled", "Not Attended", "Not Shortlisted"] as const;

// ---------- TYPES ----------
type StatusType = (typeof STATUSES)[number];

interface StatusTargetType {
  type: "round" | "interview";
  id: number | null;
}

const getStatusOptions = () => {
  if (statusTarget.type === "round") {
    // Hide last status
    return STATUSES.slice(0, -1);
  }
  return STATUSES;
};

// ---------- STATE ----------
const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
const [selectedStatus, setSelectedStatus] = useState<StatusType | "">("");
const [statusTarget, setStatusTarget] = useState<StatusTargetType>({
  type: "round",
  id: null,
});
const [reason, setReason] = useState("");
const [reasonError, setReasonError] = useState("");

const handleSave = () => {
  if (statusTarget.type === "interview" && selectedStatus === "Not Shortlisted") {
    if (!reason.trim()) {
      setReasonError("Reason is required.");
      return;
    }
  }

  // Call your API normally
  updateStatus({
    round_id: statusTarget.type === "round" ? statusTarget.id : null,
    interview_id: statusTarget.type === "interview" ? statusTarget.id : null,
    status: selectedStatus,
    reason: reason || null,
  });
};

useLayoutEffect(() => {
  if (pageSize === 0) return; // Prevent setting height too early
  const calculateHeight = () => {
    const baseOffset = 194;
    const extraOffset = window.innerWidth <= 991 ? -75 : -81;
    const fixedOffset = baseOffset + extraOffset;
  
    const newHeight = window.innerHeight - fixedOffset;
  
    console.log('Calculated table height:', newHeight);
    console.log('fixedOffset:', fixedOffset);
    console.log('window.innerHeight:', window.innerHeight);
    console.log("totalItems :",totalItems);
     console.log("pagesize :",pageSize);
    setTableHeight(newHeight);
  };
   calculateHeight(); 
  window.addEventListener("resize", calculateHeight); // respond to window size changes

    return () => window.removeEventListener("resize", calculateHeight); // cleanup on unmount
  }, []);

  const [interviews, setInterviews] = useState<any[]>([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailData, setDetailData] = useState<any>(null);
  const [selectedInterview, setSelectedInterview] = useState<InterviewRecord | null>(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [selectedRound, setSelectedRound] = useState<InterviewRound | null>(null);
  const [interviewers, setInterviewers] = useState<any[]>([]);
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userRole = storedUser?.role_name; 
  const userId = storedUser?.id; 
  const [isHR, setIsHR] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [interviewId, setInterviewId] = useState();
  const [rescheduleData, setRescheduleData] = useState({
    round_id: null,
    new_datetime: "",
    reason: "",
    meeting_link: "",
  });
const [confirmStatus, setConfirmStatus] = useState<string | null>(null);

  const rescheduleModalRef = useRef<any>(null);
  const hideBsModal = (id: string) => {
      const el = document.getElementById(id);
      if (!el) return;
      const bsModal = (window as any).bootstrap.Modal.getInstance(el) 
                  ?? (new (window as any).bootstrap.Modal(el));
      bsModal.hide();
      setTimeout(() => {
        document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
      }, 300);
    };

const { hideModal } = useModalWithUrlCleanup(hideBsModal);

useEffect(() => {
  const el = document.getElementById("reschedule_modal");
  if (el) {
    rescheduleModalRef.current = new window.bootstrap.Modal(el, {
      backdrop: "static",
      keyboard: false,
    });
  }
}, []);

const openRescheduleModal = (round: any) => {
  setRescheduleData({
    round_id: round.id,
    new_datetime: "",
    reason: "",
    meeting_link: round.meeting_link,
  });

  setRescheduleError({
    new_datetime: "",
    reason: "",
    meeting_link: "",
  });

  // Close rounds modal first
  hideModal("interview_rounds_modal");

  // Open reschedule modal after hiding the previous modal
  const roundsEl = document.getElementById("interview_rounds_modal");
  if (roundsEl) {
    roundsEl.addEventListener(
      "hidden.bs.modal",
      () => {
        rescheduleModalRef.current?.show();
      },
      { once: true }
    );
  }
};


  const fetchDesignation = async () => {
    try {
      const res = await nodeApi<any>(`/interviews/is-hr/${storedUser?.designation_id}`);
      return res?.isHR || false;
    } catch (err) {
      console.error("Error fetching designation:", err);
      return "";
    }
  };

  useEffect(() => {
    const loadDesignation = async () => {
      const isHR = await fetchDesignation();
      setIsHR(isHR);
    };

    if (storedUser?.designation_id) {
      loadDesignation();
    }
  }, [storedUser?.designation_id]);


  const fetchInterviews = async () => {
    try {
      setLoading(true);
      const res = await nodeApi<any>(
        `/interviews/list-interviews`, {
            method: 'POST',
            body: { role: userRole, userId, currentPage, pageSize, },
        }
      );
      console.log("Raw API response:", res);
      setInterviews(res?.data);
      setTotalItems(res?.pagination?.totalRecords);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
       if (isInitialFetch.current) {
        isInitialFetch.current = false;
        return;
      }
      fetchInterviews();
    }, [currentPage, pageSize]);

    useEffect(() => {
    if (!interviewIdFromURL) return;

    const loadInterview = async () => {
      try {
        const res:any = await nodeApi(
        `/interviews/interview`, {
            method: 'POST',
            body: { role: userRole, userId, id: interviewIdFromURL },
        }
      );
        if (res?.data) {
          setSelectedInterview(res.data);
          showBsModal("interview_rounds_modal");
        }
      } catch (err) {
        console.error("Error loading interview:", err);
      }
    };

    loadInterview();
  }, [interviewIdFromURL]);

    const handleViewDetails = (candidate: any) => {
      setDetailData(candidate);   // directly set candidate object
      setDetailLoading(false);
      showBsModal("resume_details_modal");
    };

    const handleOpenResume = (file_name: any) => {
      const url = file_name;
      if (!url) return toast.error("Resume link not found");
      window.open(url, "_blank", "noopener,noreferrer");
    };
    
    // --- Modal helpers (Bootstrap) ---
    const showBsModal = (id: string) => {
      const el = document.getElementById(id);
      if (!el) return;
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    };

    const initialsOf = (name?: string) =>
    (name || "")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((s) => s[0]?.toUpperCase())
      .join("");

      const openInterviewModal = (rec: any) => {
        setSelectedInterview(rec);
        showBsModal("interview_rounds_modal");
      };

  // const approveRound = async (round: any) => {
  //   try {
  //     const res: any = await nodeApi("/interviews/approve-round", {
  //       method: "POST",
  //       body: {
  //         round_id: round.id,
  //         interviewer_id: storedUser.id
  //       }
  //     });

  //     toast.success(res?.message);
  //     fetchInterviews(); // reload list
  //   } catch (err: any) {
  //     toast.error(err.message);
  //   }
  // };

  const [rescheduleError, setRescheduleError] = useState({
  new_datetime: "",
  reason: "",
  meeting_link: "",
});

  const [isSaving, setIsSaving] = useState(false);

const submitReschedule = async () => {
  const errors: any = {};

  if (!rescheduleData.new_datetime) errors.new_datetime = "Date & time is required";
  if (!rescheduleData.reason.trim()) errors.reason = "Reason is required";
  if (!rescheduleData.meeting_link.trim()) errors.meeting_link = "Meeting link is required";

  setRescheduleError(errors);

  if (Object.keys(errors).length > 0) return;
  setIsSaving(true);

  try {
    const res:any = await nodeApi("/interviews/reschedule-round", {
      method: "POST",
      body: rescheduleData,
    });

    if (res.success) {
      toast.success("Interview rescheduled successfully");
      rescheduleModalRef.current?.hide();
      fetchInterviews();
    } else {
      toast.error(res.message || "Failed to reschedule");
    }
  }  catch (err: any) {
        const backendMessage = err?.response?.data?.message;
        console.error("Error:", backendMessage);
        toast.error(backendMessage || "API failed");
  } finally {
      setIsSaving(false);
    }
};


  const fetchInterviewers = async () => {
      try {
        const res = await nodeApi<any>(
          `/interviews/interviewers`
        );
        setInterviewers(res.data || []);
      } catch (err: any) {
        console.error("Fetch error:", err.message);
      }
    };

    useEffect(() => {
      fetchInterviewers();
    }, []);

    const getInterviewerName = (id: number): string => {
      const found = interviewers.find((iv) => iv.id === id);
      return found ? found.name : `Interviewer ${id}`;
    };

    useEffect(() => {
      if (selectedCandidate && selectedJob && interviewMode === "newRound") {
        console.log("DATA=",selectedCandidate)
        hideModal("interview_rounds_modal")
        // Open modal after hiding the previous modal
        const roundsEl = document.getElementById("interview_rounds_modal");
        if (roundsEl) {
          roundsEl.addEventListener(
            "hidden.bs.modal",
            () => {
              setShowInterviewModal(true);
            },
            { once: true }
          );
        }
      }
    }, [selectedCandidate, selectedJob, interviewMode]);


   const scheduleNewRound = async (interview: any) => {
  try {
    const candidate = interview.candidate;
    const jobOpening = interview.jobOpening;
    setInterviewId(interview.id)
    setSelectedCandidate(candidate);
    setSelectedJob(jobOpening);
    setInterviewMode("newRound");
  } catch (err: any) {
    toast.error("Failed to load candidate details");
  }
};


const handleSuccess = () => {
    toast.success("New interview round scheduled successfully!");
    fetchInterviews();
};

const handleCloseModal = () => {
  setSelectedJob(null);
  setShowInterviewModal(false);
};

const handleConfirmSubmit = () => {
  if (!selectedRound) return;
  hideModal("interview_rounds_modal")
  submitFeedbackToHR(selectedRound);
};

const submitFeedbackToHR = async (round: any) => {
  try {
    const response: any = await nodeApi("/interviews/submit-feedback", {
      method: "POST",
      body: {
        round_id: round.id,
        interviewer_id: storedUser?.id
      }
    });

    if (response?.success) {
      toast.success("Feedback submission recorded & HR notified!");
      setShowConfirmPopup(false);
      fetchInterviews(); 
    } else {
      toast.error("API failed: Unable to submit feedback");
    }

  } catch (err: any) {
        const backendMessage = err?.response?.data?.message;
        console.error("Error:", backendMessage);
        toast.error(backendMessage || "API failed: Unable to submit feedback");
  } finally{
      setShowConfirmPopup(false)
  }
};

const updateStatus = async ({
  round_id = null,
  interview_id = null,
  status,
  reason = null
}: {
  round_id?: number | null;
  interview_id?: number | null;
  status: string;
  reason?: string | null;
}) => {
  try {
    if (!status) {
      toast.error("Status is required");
      return;
    }

    if (
      (!round_id && !interview_id) ||
      (round_id && interview_id)
    ) {
      toast.error("Send ONLY one of round_id OR interview_id");
      return;
    }

    const response: any = await nodeApi("/interviews/update-status", {
      method: "POST",
      body: {
        round_id,
        interview_id,
        status,
        reason
      },
    });

    if (response?.success) {
      toast.success(`Status updated to ${status}`);
      fetchInterviews();
      setShowStatusModal(false);
      hideModal("interview_rounds_modal");
    } else {
      toast.error("Failed: Could not update status");
    }
  } catch (err: any) {
    const backendMessage = err?.response?.data?.message;
    console.error("Error:", backendMessage);
    toast.error(backendMessage || "API failed: Could not update status");
  }
};

const openStatusModal = (type: "round" | "interview", id: number) => {
  setStatusTarget({ type, id });
  setSelectedStatus(""); // reset selection
  setReason("")
  setReasonError("")
  setShowStatusModal(true);
};

const getLatestRound = (rounds: any[] = []): any => {
  if (!Array.isArray(rounds) || rounds.length === 0) return null;

  return rounds
    .filter(r => r?.scheduled_datetime)
    .sort(
      (a, b) =>
        new Date(b.scheduled_datetime).getTime() -
        new Date(a.scheduled_datetime).getTime()
    )[0];
};

  const columns = [
    {
  title: "Name",
  dataIndex: "name",
  width: 180,
  render: (_: any, rec: any) => {
    const maxNameLength = 15;
    const maxEmailLength = 20;

    const truncate = (text: string, max: number) =>
      text?.length > max ? text.substring(0, max) + "..." : text;

    return (
      <div style={{ minWidth: 0 }}>
        <a
          href="#"
          className="fw-medium text-decoration-none"
          onClick={(e) => {
            e.preventDefault();

            if (userRole === 2) {
              if (rec.candidate?.file_name) {
                window.open(rec.candidate.file_name, "_blank");
              } else {
                alert("Resume is not uploaded.");
              }
            } else {
              handleViewDetails(rec.candidate);
            }
          }}
          title={userRole === 2 ? "Open Resume" : "Open candidate details"}
        >
          {truncate(rec.candidate.name, maxNameLength)}
        </a>

        <div className="text-muted small" style={{marginTop:"-4px"}}>
          {rec.candidate.email
            ? truncate(rec.candidate.email, maxEmailLength)
            : "—"}
        </div>
      </div>
    );
  },
},
  {
    title: "Job Profile",
    dataIndex: "jobOpening",
    width: 180,
    ellipsis: true,
    render: (_: any, rec: any) => {
      const value = rec?.jobOpening?.job_profile || "-";
      return <span title={value}>{value}</span>;
    }
  },
{
  title: "Status",
  dataIndex: "record",
  width: 180,
  ellipsis: true,
  align: "center",
  render: (_: any, record: any) => {
    const status = record.status;

    // Normalize communication_log to an array
    let logs: any[] = [];
    if (Array.isArray(record.communication_log)) {
      logs = record.communication_log;
    } else if (typeof record.communication_log === "string") {
      try {
        logs = JSON.parse(record.communication_log);
      } catch {
        logs = [];
      }
    }

    // Filter only status_update logs with Not Shortlisted
    const statusLogs = logs.filter(
      (log: any) => log.type === "status_update" && log.status === "Not Shortlisted"
    );

    // Get latest log by timestamp
    const latestLog = statusLogs.sort(
      (a: any, b: any) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    )[0];

    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <span>{status || "-"}</span>

        {status === "Not Shortlisted" && latestLog?.reason && (
          <i
            className="ti ti-info-circle ms-1 text-muted"
            style={{ cursor: "pointer" }}
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="false"
            title={latestLog.reason}
          />
        )}
      </div>
    );
  },
},
   {
    title: "Progress Status",
    dataIndex: "rounds",
    width: 200,
    ellipsis: true,
    render: (_: any, rec: any) => {
      const latest = getLatestRound(rec.rounds);

      if (!latest) return "-";

      return (
         <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <span className="fw-medium">{latest.interview_type}</span>
          <span className="text-muted"> - </span>
          <span>{latest.status || "-"}</span>
        </div>
      );
    }
  },
  {
    title: "Scheduled On",
    dataIndex: "scheduled",
    width: 180,
    ellipsis: true,
    render: (_: any, rec: any) => {
      const latest = getLatestRound(rec.rounds);

      if (!latest?.scheduled_datetime) return "-";

      return dayjs(latest.scheduled_datetime).format("DD-MMM-YYYY, h:mm A");
    }
  },
  {
    title: "Action",
    dataIndex: "actions",
    width: 80,
    align: "center",
    render: (_: any, rec: any) => (
      <div className="action-icon d-inline-flex">
        <Link
          to="#"
          title="View Round Details"
          onClick={(e) => {
            e.preventDefault();
            openInterviewModal(rec);
          }}
        >
          <i className="ti ti-eye" />
        </Link>

        {userRole === 1 && isHR && (
          <Link
          to="#"
          title="Change Status"
          onClick={(e) => {
            e.preventDefault();
            openStatusModal("interview", rec.id)
          }}
        >
          <i className="ti ti-edit" />
        </Link>
        )}
      </div>
    ),
  }
  ];

  return (
    <>
    <div className="page-wrapper d-flex flex-column notifs">
      <div className="content flex-grow-1 " >
        <div className="card card-margin-bottom" ><div className="card-body p-0" id="payheader-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
        <Table  style={{ flex: 1 }} loading={loading} currentPage={currentPage} dataSource={interviews} columns={columns} onPageChange={setCurrentPage} totalItems={totalItems} pageSize={pageSize} />
      </div></div></div>

      {/* Details Modal */}
      <div className="modal fade" id="resume_details_modal" tabIndex={-1}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                      <div className="modal-content border-0 shadow-lg">
                        <div className="modal-header border-0 pb-0">
                          <div className="d-flex align-items-center gap-3">
                            {/* Professional avatar with initials */}
                            <div
                              className="d-flex align-items-center justify-content-center text-white"
                              style={{
                                width: 56,
                                height: 56,
                                borderRadius: "14px",
                                background:
                                  "linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)",
                                fontSize: 20,
                                fontWeight: 600,
                              }}
                              aria-hidden
                            >
                              {initialsOf(detailData?.name) || "CN"}
                            </div>
      
                            <div>
                              <h5 className="modal-title mb-0">{detailData?.name || "Candidate"}</h5>
                              <div className="text-muted small">
                                {detailData?.designation || "—"} · {detailData?.current_location || "—"}
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => hideBsModal("resume_details_modal")}
                          />
                        </div>
      
                        <div className="modal-body pt-3">
                          {/* Quick actions */}
                          <div className="d-flex flex-wrap gap-2 mb-3">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => handleOpenResume(detailData?.file_name)}
                            >
                              <i className="ti ti-file-text me-1" /> Open Resume
                            </button>
                          </div>
      
                          {/* Key facts */}
                          {detailLoading && <div>Loading...</div>}
                          {!detailLoading && (
                            <div className="row g-3">
                              <div className="col-12 col-md-6">
                                <div className="card h-100 border-0 shadow-sm">
                                  <div className="card-body">
                                    <h6 className="text-uppercase text-muted mb-3">Profile</h6>
                                    <dl className="row mb-0 small">
                                      <dt className="col-5 text-muted">Email</dt>
                                        <dd className="col-7">
                                          {detailData?.email ? (
                                            <span
                                              className="text-primary"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {detailData.email}
                                            </span>
                                          ) : (
                                            "—"
                                          )}
                                        </dd>
                                        <dt className="col-5 text-muted">Contact</dt>
                                        <dd className="col-7">
                                          {detailData?.contact_no ? (
                                            <span
                                              className="text-primary"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {detailData.contact_no}
                                            </span>
                                          ) : (
                                            "—"
                                          )}
                                        </dd>
                                      <dt className="col-5 text-muted">Experience</dt>
                                      <dd className="col-7">
                                        {(() => {
                                          const n = Number(detailData?.total_experience_months) || 0;
                                          const y = Math.floor(n / 12);
                                          const r = n % 12;
                                          if (y && r) return `${y} year${y > 1 ? "s" : ""} ${r} month${r > 1 ? "s" : ""}`;
                                          if (y) return `${y} year${y > 1 ? "s" : ""}`;
                                          return `${r} month${r !== 1 ? "s" : ""}`;
                                        })()}
                                      </dd>
      
                                      <dt className="col-5 text-muted">Source</dt>
                                      <dd className="col-7">{detailData?.source || "—"}</dd>
      
                                      <dt className="col-5 text-muted">CTC</dt>
                                      <dd className="col-7">{detailData?.ctc_info || "—"}</dd>
                                    </dl>
                                  </div>
                                </div>
                              </div>
      
                              <div className="col-12 col-md-6">
                                <div className="card h-100 border-0 shadow-sm">
                                  <div className="card-body">
                                    <h6 className="text-uppercase text-muted mb-3">Career</h6>
                                    <dl className="row mb-0 small">
                                      <dt className="col-5 text-muted">Companies Worked</dt>
                                      <dd className="col-7">{detailData?.companies_worked ?? "—"}</dd>
      
                                      <dt className="col-5 text-muted">Last Company</dt>
                                      <dd className="col-7">{detailData?.last_company || "—"}</dd>
      
                                      <dt className="col-5 text-muted">Category</dt>
                                      <dd className="col-7">{detailData?.category_name || "—"}</dd>
      
                                      <dt className="col-5 text-muted">Loyalty</dt>
                                      <dd className="col-7">
                                        {detailData?.loyalty_percentage != null ? `${detailData.loyalty_percentage}%` : "—"}
                                      </dd>
                                    </dl>
                                  </div>
                                </div>
                              </div>
      
                              {/* Skills */}
                              <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                  <div className="card-body">
                                    <h6 className="text-uppercase text-muted mb-3">Skills</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {(Array.isArray(detailData?.skills)
                                        ? detailData.skills
                                        : detailData?.skills
                                        ? String(detailData.skills).split(",")
                                        : []
                                      ).map((s: string, i: number) => (
                                        <span key={i} className="badge bg-light text-dark border">
                                          {s.trim()}
                                        </span>
                                      ))}
                                      {(!detailData?.skills ||
                                        (Array.isArray(detailData.skills) && detailData.skills.length === 0)) && (
                                        <span className="text-muted small">—</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
      
                        <div className="modal-footer border-0">
                          <button className="btn btn-light" onClick={() => hideBsModal("resume_details_modal")}>
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
      </div>

{/* Interview Rounds Modal */}
      <div
  className="modal fade"
  id="interview_rounds_modal"
  tabIndex={-1}
  aria-hidden="true"
>
  <div className="modal-dialog modal-lg modal-dialog-scrollable">
    <div className="modal-content">
       <div className="modal-header d-flex align-items-start justify-content-between flex-wrap">
    <h4
      className="modal-title d-flex flex-wrap align-items-center gap-2 rounds-header"
      style={{ margin: 0 }}
    >
      <span>Interview Rounds |</span>

      {selectedInterview?.candidate?.name && (
        <span
          className="text-muted small text-truncate candidate-name"
          title={selectedInterview.candidate.name}
        >
          {selectedInterview.candidate.name}
        </span>
      )}
    </h4>

    {/* Close button */}
    <button
      type="button"
      className="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
    />
  </div>

      <div className="modal-body">
  {!selectedInterview ? (
    <p>Loading...</p>
  ) : (
    <div>
      {selectedInterview.rounds?.length === 0 && <p>No rounds found.</p>}

      {selectedInterview?.rounds?.map((r: InterviewRound) => {
        let latestReschedule: any = null;

        if (r.reschedule_history) {
          try {
            let history = r.reschedule_history;
            if (typeof history === "string") history = JSON.parse(history);
            if (Array.isArray(history) && history.length > 0) {
              latestReschedule = history[history.length - 1];
            }
          } catch (e) {
            console.error("Invalid reschedule_history format:", e);
          }
        }

        return (
          <div key={r.id} className="p-3 mb-3 border rounded shadow-sm">
            {/* Top row: title + HR actions */}
            <div className="d-flex justify-content-between align-items-start mb-2">
              <h5 className="fw-semibold mb-0">{r.interview_type} Round</h5>

              {/* HR Change Status */}
              {userRole === 1 && isHR && (
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    openStatusModal("round", r.id)
                  }}
                >
                  Change Status
                </button>
              )}
            </div>

            {/* Round details */}
            <p className="mb-1">
              <strong>Scheduled On:</strong>{" "}
              {r.scheduled_datetime
                ? dayjs(r.scheduled_datetime).format("DD-MMM-YYYY, h:mm A")
                : "-"}
            </p>

            <p className="mb-1">
              <strong>Status:</strong> {r.status}
            </p>

            {r.status === "Rescheduled" && latestReschedule && (
              <p className="mb-1">
                <strong>Reason:</strong> {latestReschedule.reason}
              </p>
            )}

            <p className="mb-2">
              <strong>Interviewers:</strong>{" "}
              {r.interviewers
                .map((i: Interviewer) => getInterviewerName(i.interviewer_id))
                .join(", ")}
            </p>

            {/* Action buttons */}
            <div className="d-flex gap-2 mt-3 flex-wrap">
              <button
                className="btn btn-sm"
                    style={{
                      backgroundColor: "#AFC2FF",
                      color: "#3F4D92",
                      border: "none" // optional, removes default btn border
                    }}
                onClick={() => window.open(r.meeting_link, "_blank")}
                disabled={!r.meeting_link}
              >
                Join Meeting
              </button>

              {userRole === 2 && (
                <button
                   className="btn btn-sm"
                    style={{
                      backgroundColor: "#CD8B015E",
                      color: "#A87C20",
                      border: "none" // optional, removes default btn border
                    }}
                  onClick={() => window.open(r.feedback_form_link, "_blank")}
                  disabled={!r.feedback_form_link}
                >
                  Give Feedback
                </button>
              )}

              {userRole === 2 && (
                <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: "#9FF4C4",
                    color: "#34714E",
                    border: "none" // optional, removes default btn border
                  }}
                  onClick={() => {
                    setSelectedRound(r);
                    setShowConfirmPopup(true);
                  }}
                >
                  I Have Submitted Feedback
                </button>
              )}

              {userRole === 1 && isHR && (
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => openRescheduleModal(r)}
                >
                  Reschedule
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  )}
      </div>

      <div className="modal-footer">
         {userRole === 1 && isHR && (
          <button
            className="btn me-auto"
            style={{
              backgroundColor: "#9FF4C4",
              color: "#34714E",
              border: "none"
            }}
            onClick={() => {
              if (selectedInterview?.jobOpening?.status === "inactive") {
                toast.error("This job opening is inactive. You cannot schedule a new round.");
                return;
              }
              scheduleNewRound(selectedInterview);
            }}
          >
            Schedule New Round
          </button>
        )}
        <button
          className="btn btn-light"
          onClick={() => hideModal("interview_rounds_modal")}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

{showStatusModal && (
  <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Change Status</h5>
          <button className="btn-close" onClick={() => setShowStatusModal(false)}></button>
        </div>

        <div className="modal-body">

          <div className="d-flex flex-column gap-2">
            {getStatusOptions().map((s) => (
              <button
                key={s}
                className={`btn ${selectedStatus === s ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setSelectedStatus(s)}
              >
                {s}
              </button>
            ))}
          </div>

          {/* Reason only for interviews with Not Shortlisted */}
          {statusTarget.type === "interview" && selectedStatus === "Not Shortlisted" && (
          <div className="mt-3">
            <label className="form-label">
              Reason <span className="text-danger">*</span>
            </label>

            <TextareaAutosize
              className={`form-control`}
              minRows={2}
              maxRows={4}
              value={reason}
              onChange={(e) => {
                const val = e.target.value;
                setReason(val);
                if (val.trim() !== "") {
                  setReasonError("");
                }
              }}
            />
            {reasonError && <div className="text-danger">{reasonError}</div>}
          </div>
        )}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-light me-2"
            onClick={() => setShowStatusModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={
              !selectedStatus
            }
          >
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
)}

{showConfirmPopup && (
  <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Confirm Feedback Submission</h5>
          <button className="btn-close" onClick={() => setShowConfirmPopup(false)}></button>
        </div>

        <div className="modal-body">
          <p>Are you sure you have submitted the feedback form?</p>
        </div>

        <div className="modal-footer">
          <button className="btn btn-light me-2" onClick={() => setShowConfirmPopup(false)}>
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={() => handleConfirmSubmit()}
          >
            Yes, Submit
          </button>
        </div>

      </div>
    </div>
  </div>
)}

    <div
  className="modal fade"
  id="reschedule_modal"
  tabIndex={-1}
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content">

      <div className="modal-header">
        <h4 className="modal-title">Reschedule Interview</h4>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>

      <div className="modal-body">

        {/* New Date-Time */}
        <div className="mb-3">
          <label className="form-label">
            New Interview Date & Time <span className="text-danger">*</span>
          </label>

         {(() => {
            const selectedDate = rescheduleData.new_datetime
              ? new Date(rescheduleData.new_datetime)
              : null;

            const now = new Date();

            return (
              <DatePicker
                selected={selectedDate}
                onChange={(date: Date | null) => {
                  setRescheduleData({
                    ...rescheduleData,
                    new_datetime: date ? date.toISOString() : "",
                  });

                  if (date) {
                    setRescheduleError((prev) => ({
                      ...prev,
                      new_datetime: "",
                    }));
                  }
                }}
                showTimeSelect
                showTimeInput
                dateFormat="dd-MMM-yyyy, hh:mm aa"
                placeholderText="Select interview date & time"
                className={`form-control ${
                  rescheduleError.new_datetime ? "is-invalid" : ""
                }`}

                /* Disable past dates */
                minDate={now}

                /* Disable past time when today */
                minTime={
                  selectedDate &&
                  selectedDate.toDateString() === now.toDateString()
                    ? now
                    : new Date(0, 0, 0, 0, 0, 0)
                }

                maxTime={new Date(0, 0, 0, 23, 59, 59)}

                customTimeInput={
                                <CustomTimeInput
                                  date={selectedDate ?? now}
                                  timeString={
                                    selectedDate
                                      ? selectedDate.toLocaleTimeString("en-GB", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : ""
                                  }
                                  onChange={(value: string) => {
                                    if (!selectedDate) return;

                                    const [hh, mm] = value.split(":").map(Number);

                                    const updated = new Date(selectedDate);
                                    updated.setHours(hh, mm, 0, 0);

                                    const nowLocal = new Date();

                                    // Prevent selecting past times from the time list
                                    if (
                                      updated.toDateString() === nowLocal.toDateString() &&
                                      updated < nowLocal
                                    ) {
                                      return;
                                    }
                                    setRescheduleData({
                                      ...rescheduleData,
                                      new_datetime: updated.toISOString(),
                                    });
                                  }}
                                />
                              }
              />
            );
          })()}

          {/* {rescheduleError.new_datetime && (
            <div className="invalid-feedback">
              {rescheduleError.new_datetime}
            </div>
          )} */}
        </div>

        {/* Reason */}
        <div className="mb-3">
          <label className="form-label">
            Reason for Reschedule <span className="text-danger">*</span>
          </label>

          <TextareaAutosize
            className={`form-control ${rescheduleError.reason ? "is-invalid" : ""}`}
            minRows={2}
            maxRows={4}
            value={rescheduleData.reason}
            onChange={(e) => {
              setRescheduleData({ ...rescheduleData, reason: e.target.value });
              setRescheduleError((prev) => ({ ...prev, reason: "" }));
            }}
          />

          {/* {rescheduleError.reason && (
            <div className="invalid-feedback">
              {rescheduleError.reason}
            </div>
          )} */}
        </div>

        {/* Meeting Link */}
        <div className="mb-3">
          <label className="form-label">
            Meeting Link <span className="text-danger">*</span>
          </label>

          <input
            type="url"
            className={`form-control ${rescheduleError.meeting_link ? "is-invalid" : ""}`}
            value={rescheduleData.meeting_link}
            onChange={(e) => {
              setRescheduleData({
                ...rescheduleData,
                meeting_link: e.target.value,
              });

              setRescheduleError((prev) => ({
                ...prev,
                meeting_link: "",
              }));
            }}
          />

          {/* {rescheduleError.meeting_link && (
            <div className="invalid-feedback">
              {rescheduleError.meeting_link}
            </div>
          )} */}
        </div>

      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-light me-2"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button className="btn btn-primary" onClick={submitReschedule} disabled={isSaving} >
                  {isSaving ? "Saving..." : "Save"}
          </button>
      </div>

    </div>
  </div>
</div>

 {/* Schedule Interview Modal */}
      <ScheduleInterviewModal
      show={showInterviewModal}
      onClose={handleCloseModal}
      jobId={selectedJob?.id ?? 0} 
      jobProfile={selectedJob?.job_profile ?? ""} 
      interviewId={interviewId}
      mode={interviewMode}
      initialData={{
        candidateId: selectedCandidate?.id ?? undefined, // undefined if new candidate
        candidateName: selectedCandidate?.name ?? "",
        candidateEmail: selectedCandidate?.email ?? "",
        totalExperienceMonths: selectedCandidate?.total_experience_months ?? 0,
        currentCTC: selectedCandidate?.ctc_info ?? "",
        expectedCTC: selectedCandidate?.expected_ctc ?? "",
        currentLocation: selectedCandidate?.current_location ?? "",
        resumeFileName: selectedCandidate?.file_name ?? "",
      }}
      onSuccess={handleSuccess}
    />

      <Footer />
    </div>
    <ToastContainer position="top-right" autoClose={3000} /></>
  );
};
export default Interviews;
